import request from '@/utils/request'

// 获取banner列表
export function getBannerList(data) {
  return request({
    url: '/admin/operate/webBanner/list',
    method: 'post',
    data
  })
}

// 添加banner
export function addBanner(data) {
  return request({
    url: '/admin/operate/webBanner/add',
    method: 'post',
    data
  })
}

// 修改banner
export function updateBanner(data) {
  return request({
    url: '/admin/operate/webBanner/edit',
    method: 'post',
    data
  })
}
// banner排序
export function sortBanner(data) {
  return request({
    url: '/admin/operate/webBanner/sortEdit',
    method: 'post',
    data
  })
}

// 删除banner
export function removeBanner(data) {
  return request({
    url: '/admin/operate/webBanner/remove',
    method: 'post',
    data
  })
}
